import { deleteSelection } from "@tiptap/pm/commands";

import { BUBBLE_TEXT_LIST, IMAGE_SIZE, VIDEO_SIZE } from "../../constants";
import { localeActions } from "../../locales";
import { ActionButton } from "../../components";

function imageSizeMenus(editor) {
	const types = ["size-small", "size-medium", "size-large"];
	const icons = ["SizeS", "SizeM", "SizeL"];

	return types.map((size, i) => ({
		type: `image-${size}`,
		component: ActionButton,
		componentProps: {
			tooltip: localeActions.t(`editor.${size.replace("-", ".")}.tooltip`),
			icon: icons[i],
			action: () => editor.commands.updateImage({ width: IMAGE_SIZE[size] }),
			isActive: () => editor.isActive("image", { width: IMAGE_SIZE[size] })
		}
	}));
}

function imageAlignMenus(editor) {
	const types = ["left", "center", "right"];
	const iconMap = {
		left: "AlignLeft",
		center: "AlignCenter",
		right: "AlignRight"
	};
	return types.map(k => ({
		type: `image-${k}`,
		component: ActionButton,
		componentProps: {
			tooltip: localeActions.t(`editor.textalign.${k}.tooltip`),
			icon: iconMap[k],
			action: () => editor.commands?.setAlignImage?.(k),
			isActive: () => editor.isActive({ align: k }) || false,
			disabled: false
		}
	}));
}

function videoSizeMenus(editor) {
	const types = ["size-small", "size-medium", "size-large"];
	const icons = ["SizeS", "SizeM", "SizeL"];

	return types.map((size, i) => ({
		type: `video-${size}`,
		component: ActionButton,
		componentProps: {
			tooltip: localeActions.t(`editor.${size.replace("-", ".")}.tooltip`),
			icon: icons[i],
			action: () => editor.commands.updateVideo({ width: VIDEO_SIZE[size] }),
			isActive: () => editor.isActive("video", { width: VIDEO_SIZE[size] })
		}
	}));
}
export function getBubbleImage(editor) {
	return [
		...imageSizeMenus(editor),
		...imageAlignMenus(editor),
		{
			type: "remove",
			component: ActionButton,
			componentProps: {
				editor,
				tooltip: localeActions.t("editor.remove"),
				icon: "Trash2",
				action: () => {
					const { state, dispatch } = editor.view;
					deleteSelection(state, dispatch);
				}
			}
		}
	];
}

export function getBubbleVideo(editor) {
	return [
		...videoSizeMenus(editor),
		{
			type: "remove",
			component: ActionButton,
			componentProps: {
				editor,
				tooltip: localeActions.t("editor.remove"),
				icon: "Trash2",
				action: () => {
					const { state, dispatch } = editor.view;
					deleteSelection(state, dispatch);
				}
			}
		}
	];
}

/**
 * Bubble menu text list
 */
export function getBubbleText(editor, t) {
	return BUBBLE_TEXT_LIST.reduce((acc, type) => {
		if (type === "divider" && acc.length > 0) {
			return [
				...acc,
				{
					type: "divider",
					component: undefined,
					componentProps: {}
				}
			];
		}

		const ext = editor.extensionManager.extensions.find(ext => ext.name === type);
		if (ext) {
			return [...acc, ext.configure().options.button({ editor, t, extension: ext })];
		}

		return acc;
	}, []);
}
